
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqwMaIwXHdYDrHTnjEvQFKx8UHqkmZpkbbPcO7RPwo8jgMeta } from "/codebuild/output/src2981982053/src/src/pages/faq.vue?macro=true";
import { default as menub4nG0ai_imvaJt8yN_iyC7GKGJwJV0B7JbBKqQdQTzEMeta } from "/codebuild/output/src2981982053/src/src/pages/menu.vue?macro=true";
import { default as indexRw0QlCRONOUyPtdWHEvHi6NSRLSrnhqUS_wdyMuo2qkMeta } from "/codebuild/output/src2981982053/src/src/pages/index.vue?macro=true";
import { default as contact1R0BMRpLENZMJUym00SfNOc5t_45_vYHlKzr1LrHa2zaUMeta } from "/codebuild/output/src2981982053/src/src/pages/contact.vue?macro=true";
import { default as tutorial7PnAMscPYIMPaJ9VtrMJyYwVFag1ydjF7WP_45V_nYcA8Meta } from "/codebuild/output/src2981982053/src/src/pages/tutorial.vue?macro=true";
import { default as agreementI1V81_45zvCT_45i7PUfNNzO4E_RL9e7u_45j9gjcLWnYfot0Meta } from "/codebuild/output/src2981982053/src/src/pages/agreement.vue?macro=true";
import { default as about_45passlefeVwZtFS6KJd9rI5r74i0poEw5nue5n_45cr5mZ6_rMMeta } from "/codebuild/output/src2981982053/src/src/pages/about-pass.vue?macro=true";
import { default as indexd4X7gS_ZiufeoBCij_DZCoUHsi8X_454vV_PObAqUav0EMeta } from "/codebuild/output/src2981982053/src/src/pages/card/index.vue?macro=true";
import { default as _91id_935zSJWPekoEj74HayamO5oRinJs9HLFTFt_bncZo3wq8Meta } from "/codebuild/output/src2981982053/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancehU0R3G_epnIDYj31HGRg1EFu2JlWK6WIvpEggRuUn1gMeta } from "/codebuild/output/src2981982053/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_939mWklqgzhW3ML0D_lvqYzhPcfl0jrhfWLqKS8RJ_zgMMeta } from "/codebuild/output/src2981982053/src/src/pages/notice/[id].vue?macro=true";
import { default as indexArc0ZWLmhadjQIxLP4c1PQLGYUy3st4Zq1_n9uB_SLkMeta } from "/codebuild/output/src2981982053/src/src/pages/coupon/index.vue?macro=true";
import { default as indexp4B7_LoMNjsCkvyKKS7kE2wbLcbRwcKuiXAQCU3Ud_454Meta } from "/codebuild/output/src2981982053/src/src/pages/mypage/index.vue?macro=true";
import { default as index1gzFuXm2J3vNMOiSBQP_45nDoXFfw1nm_5GDSjC8EWymgMeta } from "/codebuild/output/src2981982053/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93fuEIBGQenSJA_45MFfZEU5pVoXocMYUGb2mtU5O_45EfqycMeta } from "/codebuild/output/src2981982053/src/src/pages/parking/[id].vue?macro=true";
import { default as index0hEzAUaoRB_WVcthhO5iP43esZxIgsPgB25citeW5doMeta } from "/codebuild/output/src2981982053/src/src/pages/history/index.vue?macro=true";
import { default as indexDF3jhCIpGkoZ2hEABWmwc6UpqXxE_l9gWykiBHSsYrUMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/index.vue?macro=true";
import { default as indexDFLN2hGMPa8AlzWNhjE3zrwq8q9BfoBXQZP2oaQHfN0Meta } from "/codebuild/output/src2981982053/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexVMoeQzFLmIPosFo7dfeaE_ouMYPEVxDtIp1okvxpAc4Meta } from "/codebuild/output/src2981982053/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi3tidnxH5p_JSb8nxDbOpANjVNg1DKO5yMSnkKxR9W3YMeta } from "/codebuild/output/src2981982053/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editz2XHd0xaCcvWn49Zfgxtjeqc6pyDlHfMGc_bFri4jVcMeta } from "/codebuild/output/src2981982053/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement3HXSBCIeVytUADF8CCXbAbQg7f9NMGJSefCCff_45meCEMeta } from "/codebuild/output/src2981982053/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexBhsyZiQNLOIU4cj54Fi8e3qz5NOdTAZiZSf7QaB9IAwMeta } from "/codebuild/output/src2981982053/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dcGBf8DGdxJlBGJm454IT5JdfcwkmviWRvFfxP7Fg1vkMeta } from "/codebuild/output/src2981982053/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmkikjc8kHHI53ClYhi5hcdyvvKS8b1CxxTU8qsWbEIqIMeta } from "/codebuild/output/src2981982053/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexLTS_rMjmeAiYaHKQc2DXXgNs_45yOl3XhOBi3i9I58h4YMeta } from "/codebuild/output/src2981982053/src/src/pages/card/create/index.vue?macro=true";
import { default as indexy9GJ3JE26K_45h2wLo_rMyfBDXld7vtDyQI6fEG5BRgbUMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm4zX9Po6CfrHfWAGmCk5xLxV6GVZaBDalTHkc6B2wN8gMeta } from "/codebuild/output/src2981982053/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmj2gnUMozwGBXUU2n4xcnVczgUvYz34Uat46bavic69IMeta } from "/codebuild/output/src2981982053/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeztpZuQPzlEuROwpoJQnhu8dql1ZhzK2k2D76ixFzoUUMeta } from "/codebuild/output/src2981982053/src/src/pages/membership/complete.vue?macro=true";
import { default as register4x2AJu5EmlIGZZTrUlo1RP1b_xwSDzbGV8q2oky0O3UMeta } from "/codebuild/output/src2981982053/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93705eLoUlmn6_aVsSS7VXm9GNHvZ_dgcYpP6kuXJNkIcMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmC9sgI10OU5OHrn7LmANl4_45ObiHw2YX9J6eJwjVETrtcMeta } from "/codebuild/output/src2981982053/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93cTJ_45pvCsWB12v8BJgwMYs_U8YlikSNcrQCJ561lG9qYMeta } from "/codebuild/output/src2981982053/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexr5vQU3EOUSe1kVsd5NCQ3MajczbDKNZ651RJVSwJlhgMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeTU0kDbCNOEwJGWF5mEtSQhuyBx_45druJiFs3w7gbz5tsMeta } from "/codebuild/output/src2981982053/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code6dk2SIVSyzO8gayj_FQGmgLS_MHTVWK3axNqBdmTvK0Meta } from "/codebuild/output/src2981982053/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeNvJorUytAhwSRcKwzuVlv6m09vnRcCzlDqjrFm26swsMeta } from "/codebuild/output/src2981982053/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registernjKCqzbPeV7Rrqsm3qCVjlguhyEfnCGcDtAnJBBRWWoMeta } from "/codebuild/output/src2981982053/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeS259uNqWRbma2PfDMB1j_45LBGDem2A96uV_45AQIBnFfx4Meta } from "/codebuild/output/src2981982053/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexh7ZSpYTXrl3gDwzfOmperMaZXXimjOGCh5tStWAyWdEMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmkFE5BG_45JpmYv9JIrVVwTCX2IhyUPbXgx2boqQm4CCvgMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completesY_459v7e3bABR_45YCO2EceE3OglnGKzbCrlwzXtTsoUbUMeta } from "/codebuild/output/src2981982053/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexvn0IyqNFGYeWIq3VppMJ_45NME95kUXC_bKnRkHlETnQUMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ey0pl7j1snxNNnVO8uP6J50_45Ffv0DYu_UU2Tcs3sb2sMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completerJgmGotK9_JInnOHv03zfZN3RzJIhj_rVW4DGIOZ0WgMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasZ3DFhzO3O6uyVAW592mg9Auj1rV7QOrMa_45Unf0N_45tB0Meta } from "/codebuild/output/src2981982053/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleJkrUyEqH_iIHdIDIo_45wcrxEp_45BgD6zrO69rjmPDREe0Meta } from "/codebuild/output/src2981982053/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailLjQESs43y7V4TmZTolYoJD4ZhvZ8KCjkoDF4dd0LdIYMeta } from "/codebuild/output/src2981982053/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmYtsdDGgst55cSlbeG12xz_453HvfDe3RO82vrM_KKdwdAMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentC_45jRPBidIClVNfiXDSrYgpM70iM7dr4AKqGkxeIMoCsMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmspPKRl_45DDct9M8XLoAbhN9d6_2OO5sX04P0JBWxtTTQMeta } from "/codebuild/output/src2981982053/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatebAJRmka8Xhap_KU_ZZI0NScT6uyFx1y3DSLPn85Ix_45cMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeGaEcuNDxZMOqdVZIl119KzBMrXuUjHDV8o_45WEjjPzx0Meta } from "/codebuild/output/src2981982053/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45coden0Cn_45rPpDiTphiREq_ROeGzYfW5icTIKWWJX2Leucd4Meta } from "/codebuild/output/src2981982053/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password7Xd3swNN_45T80UgSa7X02C75mQnCjaSDO9QLe_453bXs_sMeta } from "/codebuild/output/src2981982053/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasqURAfBl2BzXYRSPwSk_453Khu_45mqHXsmRY_ZyERaVnPPwMeta } from "/codebuild/output/src2981982053/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerMB4M_45yvCerN_h1lIF44T9XvgLVW2JpcKmf4mkI3GOz0Meta } from "/codebuild/output/src2981982053/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code4TQV5qXU6wIn5jRWG_U2fiUDXYryGYf3Zwh6I9va7usMeta } from "/codebuild/output/src2981982053/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexaEALGuSD0AH3j8lwepqxKtHemOv_45kRZuTCt1l_xQMO8Meta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexrnRTgjaBIgeyhBuVoH0J0TuuOie8vrW2LK1Xu6r3L3cMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexgOsSTTM5zUWUZTKMKMfIWbiaZ3XFCw8pLdgwjoMZKFkMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index07fRr2HzV95_45nCSBxXIVVzgqshciLy7RAbo89W23NxIMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateH9VLEmdTXsoO0nHSZ9at2YgphSiajdo5489_GbjisD0Meta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeyKBcJTCkHEUEpUkExyOFvjQKkjxM7b_45Zi_x2BWM_45JfIMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmB7jQHNKAuzsxtPzDOokECubPFSGcvBjAeTwO7nlW9yIMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexDPkMSZWcdOHAlJeTrHLxiWVo4xzja96TJRGJK2_IgGAMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete5Qn4GTnnYdmaIYMKF8JxO_45qd8nT9T26uBWLh6hrqltoMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update9xNNwLqXQRWeEuM5ULyL7F6Waf_2PPabTgmjjspJ0jQMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexYOIcXe_PAWq59Y7sHr_451N1pULm1sqte7FB4yj4sObu4Meta } from "/codebuild/output/src2981982053/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexjcS1xzh29F1ZkSAmcx27YhCIKuBAtWBxXluzG1rZY6gMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeU7DLZ2jGLwgUcVNryotfc9wj0j2UAwxDG2_Iyp9sSfoMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index723g5VpSKSx3ZlI5dCHBCwznyspW97B9Si6Z3fKKrhEMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeO_45y_453gF_45JX6I2JizZnLscki6VHgZhp34Jqc6a16KojsMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexFsgofqbkqHO0qyWbs4AWH8HAA7gSHH1F8WEqBUbe4YEMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexQ_Sld0M2TzkNloxnvW3LYZca5cEACz9o0H0D0GRFjG0Meta } from "/codebuild/output/src2981982053/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index5NKeRVqiVxusMseB0bsDBR0xhtrx01_45fUr4QNHCAfgAMeta } from "/codebuild/output/src2981982053/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateLCS1b0TSgPczm6pJ_wJLGGWjAi2OxunQoNVC0wtlXcAMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmxIyA_1irutZMAPpu1FHoXtKbmy4bST2ybLRSUDCgC0QMeta } from "/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menub4nG0ai_imvaJt8yN_iyC7GKGJwJV0B7JbBKqQdQTzEMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexRw0QlCRONOUyPtdWHEvHi6NSRLSrnhqUS_wdyMuo2qkMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexArc0ZWLmhadjQIxLP4c1PQLGYUy3st4Zq1_n9uB_SLkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index0hEzAUaoRB_WVcthhO5iP43esZxIgsPgB25citeW5doMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexDFLN2hGMPa8AlzWNhjE3zrwq8q9BfoBXQZP2oaQHfN0Meta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexVMoeQzFLmIPosFo7dfeaE_ouMYPEVxDtIp1okvxpAc4Meta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexLTS_rMjmeAiYaHKQc2DXXgNs_45yOl3XhOBi3i9I58h4YMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm4zX9Po6CfrHfWAGmCk5xLxV6GVZaBDalTHkc6B2wN8gMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmj2gnUMozwGBXUU2n4xcnVczgUvYz34Uat46bavic69IMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeztpZuQPzlEuROwpoJQnhu8dql1ZhzK2k2D76ixFzoUUMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register4x2AJu5EmlIGZZTrUlo1RP1b_xwSDzbGV8q2oky0O3UMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmC9sgI10OU5OHrn7LmANl4_45ObiHw2YX9J6eJwjVETrtcMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeTU0kDbCNOEwJGWF5mEtSQhuyBx_45druJiFs3w7gbz5tsMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code6dk2SIVSyzO8gayj_FQGmgLS_MHTVWK3axNqBdmTvK0Meta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeNvJorUytAhwSRcKwzuVlv6m09vnRcCzlDqjrFm26swsMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registernjKCqzbPeV7Rrqsm3qCVjlguhyEfnCGcDtAnJBBRWWoMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmkFE5BG_45JpmYv9JIrVVwTCX2IhyUPbXgx2boqQm4CCvgMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completesY_459v7e3bABR_45YCO2EceE3OglnGKzbCrlwzXtTsoUbUMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexvn0IyqNFGYeWIq3VppMJ_45NME95kUXC_bKnRkHlETnQUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completerJgmGotK9_JInnOHv03zfZN3RzJIhj_rVW4DGIOZ0WgMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleJkrUyEqH_iIHdIDIo_45wcrxEp_45BgD6zrO69rjmPDREe0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailLjQESs43y7V4TmZTolYoJD4ZhvZ8KCjkoDF4dd0LdIYMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmYtsdDGgst55cSlbeG12xz_453HvfDe3RO82vrM_KKdwdAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentC_45jRPBidIClVNfiXDSrYgpM70iM7dr4AKqGkxeIMoCsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmspPKRl_45DDct9M8XLoAbhN9d6_2OO5sX04P0JBWxtTTQMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeGaEcuNDxZMOqdVZIl119KzBMrXuUjHDV8o_45WEjjPzx0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45coden0Cn_45rPpDiTphiREq_ROeGzYfW5icTIKWWJX2Leucd4Meta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password7Xd3swNN_45T80UgSa7X02C75mQnCjaSDO9QLe_453bXs_sMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerMB4M_45yvCerN_h1lIF44T9XvgLVW2JpcKmf4mkI3GOz0Meta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code4TQV5qXU6wIn5jRWG_U2fiUDXYryGYf3Zwh6I9va7usMeta || {},
    component: () => import("/codebuild/output/src2981982053/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2981982053/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]